import React from 'react';
import { Id } from '../../../../convex/_generated/dataModel';
import { Dialog, DialogBody, DialogTitle } from '../../../../catalyst-components/dialog';
import { Field, Label } from '../../../../catalyst-components/fieldset';
import { Input } from '../../../../catalyst-components/input';
import { Button } from '../../../../catalyst-components/button';

interface AssistantTypeDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: {
    name: string;
    description: string;
    required: boolean;
  }) => Promise<void>;
  initialData?: {
    name: string;
    description?: string;
    required: boolean;
  };
  mode: 'create' | 'edit';
}

export const AssistantTypeDialog: React.FC<AssistantTypeDialogProps> = ({
  open,
  onClose,
  onSubmit,
  initialData,
  mode
}) => {
  const [name, setName] = React.useState(initialData?.name || '');
  const [description, setDescription] = React.useState(initialData?.description || '');
  const [required, setRequired] = React.useState(initialData?.required || false);

  React.useEffect(() => {
    if (initialData) {
      setName(initialData.name);
      setDescription(initialData.description || '');
      setRequired(initialData.required);
    }
  }, [initialData]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit({
      name,
      description,
      required
    });

    // Reset form
    setName('');
    setDescription('');
    setRequired(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogBody>
        <DialogTitle>{mode === 'create' ? 'Add New Assistant Type' : 'Edit Assistant Type'}</DialogTitle>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field>
            <Label>Name</Label>
            <Input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Description</Label>
            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Field>

          <Field className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={required}
              onChange={(e) => setRequired(e.target.checked)}
            />
            <Label>Required</Label>
          </Field>

          <div className="flex justify-end gap-2 mt-4">
            <Button color="light" onClick={onClose}>
              Cancel
            </Button>
            <Button color="light" type="submit">
              {mode === 'create' ? 'Create' : 'Save Changes'}
            </Button>
          </div>
        </form>
      </DialogBody>
    </Dialog>
  );
}; 